<script>
// import axios from "axios";

/**
 * Preloader component
 */
export default {
  data() {
    return {
      isLoad: false,
    };
  },
  props: {
    loading: Boolean,
    height: String,
  },
  watch: {
    loading: {
      handler(value) {
        setTimeout(() => this.isLoad = value, 100)
      },
    },
  },
  created() {
    this.isLoad = this.loading;
  },
  computed: {
    theme() {
      return this.$store.state.theme;
    },
  },
  mounted() {
    this.$el.style.height = this.height || 'auto';
  }
};
</script>

<template>
  <div class="position-relative">
    <transition-group name="fade" tag="div">
      <div class="position-absolute top-50 start-0 w-100 h-100 text-center mt-4" v-if="isLoad" :key="1">
        <b-spinner style="width: 1.625em; height:1.625em" :variant="theme === 'normal' ? 'success' : 'info'" label="Spinning"></b-spinner>
      </div>
      <div v-else :key="2">
        <slot />
      </div>
    </transition-group>
  </div>
</template>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.is-loading {
  position: relative;
}
.preloader-component {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  z-index: 999;
  width: 100%;
}
.status {
  width: 40px;
  height: 40px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -20px 0 0 -20px;
}
</style>